import { css } from 'lit';

export const style = css`
  :host {
    display: block;
    margin: 0;
  }

  .lender-edit-form {
    padding-block: var(--refi-checkout-card-padding-block, 1rem);
    padding-inline: var(--refi-checkout-card-padding-inline, 0.75rem);
  }

  @media (max-width: 744px) {
    .button-container {
      display: flex;
      flex-direction: column-reverse;
    }

    .update-lender-button {
      min-width: 100%;
    }

    .desktop-order {
      display: none;
    }

    .cancel-lender-button {
      min-width: 100%;
    }
  }

  .button-container {
    text-align: right;
  }

  .grid-columns {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .grid-rows {
    display: grid;
    grid-template-columns: auto;
  }

  .update-lender-button {
    float: right;
    margin-bottom: 0;
    margin-top: 1em;
  }

  .cancel-lender-button {
    margin-bottom: 0;
    margin-top: 1em;
  }

  @media (min-width: 745px) {
    .mobile-order {
      display: none;
    }

    .update-lender-button {
      margin-left: 1em;
    }
  }
`;
